<template>
  <div id="terms">
    <div class="ContentContainer">
      <h1 class="heading-lined mb-5">Terms & Conditions</h1>

      <h4 class="mt-4">1. Terms</h4>

      <p>CoinTrackr.com is a product of COINTRACKR LTD (reg n°13590431) Incorporated in UK.</p>

      <p>By accessing the website at <a href="https://cointrackr.com">https://cointrackr.com</a>, you are agreeing to be bound by these terms of service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site. The materials contained in this website are protected by applicable copyright and trademark law.</p>

      <h4 class="mt-4">2. Use License</h4>

      <ol type="a">
        <li>
          Permission is granted to temporarily download one copy of the materials (information or software) on our website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:

          <ol type="i">
            <li>modify or copy the materials;</li>
            <li>use the materials for any commercial purpose, or for any public display (commercial or non-commercial);</li>
            <li>attempt to decompile or reverse engineer any software contained on our;</li>
            <li>remove any copyright or other proprietary notations from the materials; or</li>
            <li>transfer the materials to another person or "mirror" the materials on any other server.</li>
          </ol>
        </li>
        <li>This license shall automatically terminate if you violate any of these restrictions and may be terminated by us at any time. Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession whether in electronic or printed format.</li>
      </ol>

      <h4 class="mt-4">3. API & Trading feature</h4>

      <ol type="a">
        <li>
          API<br />
          CoinTrackr isn’t responsible for error, low latency or temporary issues on quotes sent by exchanges who provide your API.
        </li>
        <li>
          Trading feature<br />
          CoinTrackr isn’t responsible for error, low latency or temporary issues due to our Trading feature connected to the API exchange you’ve recorded.<br />
          We encourage you to always double check if orders passed through CoinTrackr were correctly posted in your Exchange account.
        </li>
      </ol>

      <h4 class="mt-4">4. Disclaimer</h4>

      <ol type="a">
        <li>The materials on our website are provided on an 'as is' basis. We make no warranties, expressed or implied, and hereby disclaim and negate all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</li>
        <li>Further, we do not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site.</li>
      </ol>

      <h4 class="mt-4">5. Limitations</h4>

      <p>In no event shall we or its suppliers be liable for any damages (including, without limitation, damages for
        loss of data or profit, or due to business interruption) arising out of the use or inability to use the
        materials on our website, even if we or a our authorized representative has been notified orally or in writing
        of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or
        limitations of liability for consequential or incidental damages, these limitations may not apply to you.</p>

      <h4 class="mt-4">6. Accuracy of materials</h4>

      <p>The materials appearing on our website could include technical, typographical, or photographic errors. We do
        not warrant that any of the materials on its website are accurate, complete or current. We may make changes to
        the materials contained on its website at any time without notice. However, do not make any commitment to update
        the materials.</p>

      <h4 class="mt-4">7. Links</h4>

      <p>We have not reviewed all of the sites linked to our website and we are not responsible for the contents of any
        such linked site. The inclusion of any link does not imply endorsement by us of any kind, of the site. Use of
        any such linked website is at the user's own risk.</p>

      <h4 class="mt-4">8. Modifications</h4>

      <p>We reserve the right to revise these terms for our website at any time without notice. By using this website
        you are agreeing to be bound by the then current version of these terms of service.</p>

      <h4 class="mt-4">9. Governing Law</h4>

      <p>These terms and conditions are governed by and construed in accordance with the laws of United Kingdom and you
        irrevocably submit to the exclusive jurisdiction of the courts in that location.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Terms",
  metaInfo: {
    title: "Terms CoinTrackr", 
  },
};
</script>
